export const it = {
  HOME: '/',
  CONTENT: '/[...content]',
  NEWS_LISTING: '/notizia',
  NEWS_LISTING_BY_SLUG: '/notizia/elenco/[newsListing]',
  NEWS_CATEGORY: '/notizia/categoria',
  NEWS_TAG: '/notizia/etichetta/[tag]',
  ARTICLE: '/notizia/[article]',
  MATCH_CENTRE: '/partite/[team]/[fixture]',
  FIXTURES: '/partite/[team]/appuntamenti',
  FIXTURES_COMPETITION: '/partite/[team]/appuntamenti/[competition]',
  RESULTS: '/partite/[team]/risultati',
  RESULTS_COMPETITION: '/partite/[team]/risultati/[competition]',
  RESULTS_COMPETITION_SEASON:
    '/partite/[team]/risultati/[competition]/[season]',
  TABLE: '/partite/[team]/tabellone',
  TABLE_COMPETITION: '/partite/[team]/tabellone/[competition]',
  TABLE_COMPETITION_SEASON: '/partite/[team]/tabellone/[competition]/[season]',
  TEAM: '/squadre/[team]',
  PROFILE: '/squadre/[team]/[profile]',
  TEAM_YOUTH: '/squadre/giovanili/[team]',
  PROFILE_YOUTH: '/squadre/giovanili/[team]/[profile]',
  VIDEO_LANDING: '/video',
  VIDEO_DETAIL: '/video/[slug]',
  VIDEO_CATEGORY: '/video/categoria/[category]',
  VIDEO_PLAYLIST_LISTING: '/video/playlists',
  VIDEO_PLAYLIST: '/video/playlists/[slug]',
  VIDEO_COLLECTION: '/video/playlists/[slug]',
} as const;
